import { render, staticRenderFns } from "./Classificar.vue?vue&type=template&id=184b55aa&scoped=true"
import script from "./Classificar.vue?vue&type=script&lang=js"
export * from "./Classificar.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Classificar.vue?vue&type=style&index=1&id=184b55aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b55aa",
  null
  
)

export default component.exports